import AcosoLaboral from '../../assets/images/courses/ACOSO.jpg'
import RiesgosBiologicos from '../../assets/images/courses/RIESGOS_BIOLOGICOS.jpg'
import RiesgosFisicos from '../../assets/images/courses/RIESGOS_FISICOS.jpg'
import SCTR from '../../assets/images/courses/SCTR.jpg'
import TransitoPeatonal from '../../assets/images/courses/TRANSITO.jpg'

import Actos from '../../assets/images/courses/ACTOS.jpg'
import Extintores from '../../assets/images/courses/EXTINTORES.jpg'

import ProteccionPersonal from '../../assets/images/courses/PROTECCION_PERSONAL.jpg'
import SistemaIntegrado from '../../assets/images/courses/SISTEMA_INTEGRADO.jpg'

export const COURSE_IMAGES = [
    {
        path: '/riesgos_fisicos',
        image: RiesgosFisicos
    }, 
    {
        path: '/seguro',
        image: SCTR
    },
    {
        path: '/riesgos_biologicos',
        image: RiesgosBiologicos
    },
    {
        path: '/acoso_laboral',
        image: AcosoLaboral
    },
    {
        path: '/transito_peatonal',
        image: TransitoPeatonal
    },
    {
        path: '/extintores',
        image: Extintores
    },
    {
        path: '/actos_condiciones',
        image: Actos
    },
    {
        path: '/proteccion_personal',
        image: ProteccionPersonal
    },
    {
        path: '/sistema_gestion',
        image: SistemaIntegrado
    }
]